import React, { useState, useEffect } from 'react';
import validator from 'validator';
import axios from 'axios';
import { defaultVariables } from '../../../../config/index';
import { localizeApiFieldError } from '../../../../config/apiValidation';
import { connect } from "trim-redux";
import {InputAdornment, MenuItem, TextField} from "@mui/material";
import { withStyles } from '@mui/styles';
import Grid from '@mui/material/Grid2';
import LoadingButton from "../../../components/elements/LoadingButton";
import { Styles } from '../../../../config/design/styles';
import {useSnackbar} from "notistack";
import CssBaseline from "@mui/material/CssBaseline";
import AppCardLoaderFields from "../../../components/loaders/AppCardLoaderFields";
import {isAdmin, rolesWithName} from "../../../../config/Permissions";
import {useNavigate} from "react-router-dom";
import SubTitle from "../../../components/elements/SubTitle";
import SingleImageChooser from "../../fileManager/Components/SingleImageChooser";
import {useTranslation} from "react-i18next";
import RayaField from "../../../components/elements/fields/RayaField";
import MobileField from "../../../components/elements/fields/MobileField";

const AddUser = (props) => {
    const { classes } = props;
    const navigation = useNavigate();

    const [fields, setFields] = useState({
        email: '',
        mobile: '',
        country: null,
        first_name: '',
        last_name: '',
        birthdate: "",
        role: 'user',
    });
    const [errors, setErrors] = useState({});
    const [avatar, setAvatar] = useState(null);
    const { t } = useTranslation();

    const [loading, setLoading] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFields((prevFields) => ({ ...prevFields, [name]: value }));
        setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    };
    const setMobileField = (country, mobile) => {
        setFields((prevFields) => ({
            ...prevFields,
            country,
            mobile
        }));
        setErrors((prevErrors) => ({ ...prevErrors, mobile: '' }));
    };
    const handleValidation = async (callback) => {
        let formIsValid = true;
        let newErrors = {};

        // Validation for full_name
        if (validator.isEmpty(fields.first_name)) {
            formIsValid = false;
            newErrors.first_name = t('emptyField');
        } else if (!validator.isByteLength(fields.first_name, { min: 0, max: 255 })) {
            formIsValid = false;
            newErrors.first_name = t('maxLength255');
        }
        // Validation for full_name
        if (validator.isEmpty(fields.last_name)) {
            formIsValid = false;
            newErrors.last_name = t('emptyField');
        } else if (!validator.isByteLength(fields.last_name, { min: 0, max: 255 })) {
            formIsValid = false;
            newErrors.last_name = t('maxLength255');
        }


        // Validation for mobile
        if (validator.isEmpty(fields.mobile)) {

        }else if(fields.mobile.length < 9 ){
            formIsValid = false;
            newErrors.mobile = t('wrongMobile');
        }
        // Validation for email
        if (validator.isEmpty(fields.email)) {

        } else if (!validator.isEmail(fields.email)) {
            formIsValid = false;
            newErrors.email = t('wrongEmail');
        }
        if(!fields.mobile && !fields.email){
            formIsValid = false;
            enqueueSnackbar(t('setMobileOrEmail'), { variant: 'warning' });

        }
        if(!!formIsValid){
            // API check for email and mobile
            const data = new FormData();
            data.append('email', fields.email);
            if(fields.mobile && fields.country){
                let mobile = Number(fields.mobile).toString();
                mobile = fields.country?.phonecode+mobile;
                data.append("mobile", mobile);
            }

            const loginToken = localStorage.getItem('ACT');
            const config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };

            try {
                const response = await axios.post(`${defaultVariables.url}/auth/check-info`, data, config);
                const apiErrors = response.data.errors;
                if (apiErrors.mobile) {
                    formIsValid = false;
                    newErrors.mobile = localizeApiFieldError("mobile", apiErrors.mobile[0], t);
                }
                if (apiErrors.email) {
                    formIsValid = false;
                    newErrors.email = localizeApiFieldError("email", apiErrors.email[0], t);
                }
                if (apiErrors.username) {
                    formIsValid = false;
                    newErrors.username = apiErrors.username[0];
                }
            } catch (error) {
                console.error(error);
            }
        }
        setErrors(newErrors);
        if (!formIsValid) setSubmitLoading(false);
        callback(formIsValid);
    };

    const handleRequest = async () => {

        const data = new FormData();
        data.append('first_name', fields.first_name);
        data.append('last_name', fields.last_name);
        if(!!fields.email){
            data.append('email', fields.email);
        }
        if(!!fields.mobile && fields.country){
            let mobile = Number(fields.mobile).toString();
            mobile = fields.country?.phonecode+mobile;
            data.append("mobile", mobile);
            data.append("code", fields.country?.phonecode);
        }
        data.append('birthdate', fields.birthdate);
        data.append('role', fields.role);

        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };

        try {
            const response = await axios.post(`${defaultVariables.url}/users/make`, data, config);
            enqueueSnackbar(t('detailsSet'), { variant: 'success' });
            setSubmitLoading(false);
            navigation(`/panel/manage/users/view-all`);
        } catch (error) {
            console.error(error.response);
            setSubmitLoading(false);
            enqueueSnackbar(t('detailsSetFailed'), { variant: 'error' });
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitLoading(true);
        handleValidation((valid) => {
            if (valid) handleRequest();
        });
    };


    if (loading) {
        return <AppCardLoaderFields />;
    }

    return (
        <Grid container spacing={2}>
            <CssBaseline />
            <Grid item size={{xs:12}}>
                <RayaField
                    variant="outlined"
                    required
                    fullWidth
                    label={t('first_name')}
                    name="first_name"
                    value={fields.first_name}
                    onChange={handleChange}
                    error={!!errors.first_name}
                    helperText={errors.first_name}
                />
            </Grid>
            <Grid item size={{xs:12}}>
                <RayaField
                    variant="outlined"
                    required
                    fullWidth
                    label={t('last_name')}
                    name="last_name"
                    value={fields.last_name}
                    onChange={handleChange}
                    error={!!errors.last_name}
                    helperText={errors.last_name}
                />
            </Grid>
            <Grid item size={{xs:12}}>
                <RayaField
                    fullWidth
                    optional
                    variant="outlined"
                    value={fields.birthdate}
                    label={t('birthdate')}
                    name="birthdate"
                    type="date"
                    onChange={handleChange}
                    error={!!errors['birthdate']}
                    helperText={errors['birthdate']}
                />
            </Grid>
            <Grid item size={{xs:12}}>
                <RayaField
                    variant="outlined"
                    required
                    fullWidth
                    id="email"
                    label={t('email')}
                    name="email"
                    autoComplete="email"
                    value={fields.email}
                    onChange={handleChange}
                    error={!!errors.email}
                    helperText={errors.email}
                />
            </Grid>
            <Grid item size={{xs:12}}>
                <MobileField
                    setMobile={setMobileField}
                    error={errors['mobile']}
                />
            </Grid>

            {
                isAdmin() &&
                <Grid item size={{xs:12}}>
                    <RayaField
                        select
                        fullWidth
                        variant="outlined"
                        required
                        name="role"
                        id="role"
                        label={t('role')}
                        value={fields.role}
                        onChange={handleChange}
                    >
                        {rolesWithName().map((row, key) => (
                            <MenuItem value={row.value} key={key}>
                                {row.name}
                            </MenuItem>
                        ))}
                    </RayaField>
                </Grid>
            }
            <Grid item size={12}>
                <LoadingButton
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    loading={submitLoading}
                >
                    {t('setDetails')}
                </LoadingButton>
            </Grid>
        </Grid>

    );
};

const mstp = (state) => ({
    isAuth: state.isAuth,
    user: state.user
});

export default withStyles(Styles)(connect(mstp)(AddUser));
